/* eslint-disable jsx-a11y/anchor-is-valid */

import { observer } from 'mobx-react-lite';
import { useLocation, useNavigate, Link } from 'react-router-dom';

import Box from '@mui/joy/Box';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import List from '@mui/joy/List';
import ListItem from '@mui/joy/ListItem';
import ListItemButton from '@mui/joy/ListItemButton';
import ListItemDecorator from '@mui/joy/ListItemDecorator';
import ListItemContent from '@mui/joy/ListItemContent';
import Tooltip from '@mui/joy/Tooltip';
import Chip from '@mui/joy/Chip';
//import Link from 'components/Link';


import SidebarClient from 'components/SidebarClient';
// import SidebarMutuals from 'components/SidebarMutuals';
import SidebarAssistant from 'components/SidebarAssistant';
import SidebarList from 'components/SidebarList';
import FancyHandsLogo from 'components/FancyHandsLogo';
// import DayOneLogo from 'components/DayOneLogo';
import { SmallLogo }  from 'components/CombinedLogo';


import useUserIdentity from 'hooks/useUserIdentity';
import useRoles from 'hooks/useRoles';
import useSidebar from 'hooks/useSidebar';

import { getIcon } from 'utils/misc';
import useSocketIO from 'hooks/useSocketIO';
import { ColorPaletteProp } from '@mui/joy';
import IconLink from 'components/IconLink';
import AssistantOnly from 'components/AssistantOnly';

// import { showReportDialog } from '@sentry/react';
// import CopyFancyHandsBullets from './CopyFancyHandsBullets';

export const XS_SIZE = 'var(--joy-fontSize-xl2)';
export const SM_SIZE = 'var(--joy-fontSize-lg)';

export function SidebarLink({ to, children, ...rest }: any) {
    const { showingSidebar, setShowingSidebar } = useSidebar();
    function updateSidebar() {
        if (showingSidebar) {
            setShowingSidebar && setShowingSidebar(false);
        }
    }
    return (
        <Link to={to} {...rest} onClick={() => {console.log('click click'); updateSidebar()}}>
            <Stack
                className="sidebar-link"
                sx={{
                fontSize: {
                    xs: XS_SIZE,
                    sm: SM_SIZE,
                },
            }}
        >
                {children}
            </Stack>
        </Link>
    );
}




const Sidebar = observer(() => {
    const location = useLocation();
    const { showingRegularSidebar, setShowingRegularSidebar, showingSidebar } = useSidebar();

    const { currentIdentity } = useUserIdentity();
    const navigate = useNavigate();

    const SupportAgentIcon = getIcon('SupportAgent');
    const ContactSupportIcon = getIcon('ContactSupportOutlined');
    const AdminPanelSettingsOutlined = getIcon('AdminPanelSettingsOutlined');

    // const AccountIcon = getIcon('ContactPageOutlined');

    const { rolesNames, hasRole } = useRoles();

    const { connectionState, connectionRetryDelay } = useSocketIO();


    const parts = location.pathname.split('/');

    const path = location.pathname;
    const section = parts[1];
    const fullScreen = path =='/sidebar';
    const tooltipPlacement = fullScreen ? 'bottom-end' : 'right';
    const Home = path == '/' ? getIcon('CottageTwoTone') : getIcon('Home');
    const SettingsIcon = ['/settings', '/account'].includes(path)  ? getIcon('SettingsTwoTone') : getIcon('SettingsOutlined');
    const CopyrightIcon = getIcon('Copyright');
    const PinSidebarIcon = getIcon('PushPinOutlined');
    const HideSidebarIcon = getIcon('ArrowBack');
    const year = new Date().getFullYear();


    var connectionStateColor = 'neutral' as ColorPaletteProp;
    if (connectionState == 'connected') {
        connectionStateColor = 'success';
    }
      else if (connectionState == 'connecting') {
        connectionStateColor = 'warning';
    }
    else if (connectionState == 'disconnected') {
        connectionStateColor = 'danger';
    }

    // console.log("path: %o", path);
    //    const dayOnefontSize = size === "xs" ? "16pt" : size === "sm" ? "20pt" : "24pt";

    return (
        <Stack>
            <Box
                sx={{
                    minHeight: 0,
                    overflow: 'hidden auto',
                    display: 'flex',
                    flexDirection: 'column',

                }}
        >


            {!fullScreen && !showingSidebar &&
                <Stack mt={1} display={{ xs: 'none', sm: 'flex' }}>
                { false && hasRole('trusted-tester') ?
                    <SmallLogo/> :
                    <FancyHandsLogo />}
                    </Stack>
            }

                <SidebarList>

                    <SidebarLink to="/">
                        <ListItem sx={{ mb: 1 }}>
                            <ListItemButton
                                variant={!section ? "soft" : undefined}
                                color={!section ? "primary" : undefined}
                            >
                                <ListItemDecorator>
                                    <Home color="primary"  />
                                </ListItemDecorator>
                                <ListItemContent>Home</ListItemContent>
                            </ListItemButton>
                        </ListItem>
                    </SidebarLink>

                    { currentIdentity.role == 'client' &&
                        <SidebarClient  />}

                    {currentIdentity.role == 'assistant' &&
                        <SidebarAssistant tooltipPlacement={tooltipPlacement} />}


                    <AssistantOnly>
                        <List
                            sx={{
                                '--ListItem-radius': '8px',
                                '--List-gap': '4px',
                                // '--List-padding': '8px',
                                '--List-nestedInsetStart': '40px',
                            }}
                        >

                            <AssistantOnly>
                                {/* only for support users */}
                                <IconLink
                                    role="support"
                                    url={`/dedicated?assistant=${currentIdentity.uuid}`}
                                    icon="DayOnesDedicated"
                                    title="Dedicated" />
                            </AssistantOnly>

                        </List>
                    </AssistantOnly>



                    {currentIdentity.role == 'assistant' && rolesNames.includes('support') &&
                        <AssistantOnly>
                            <SidebarLink to="/support/dashboard">
                                <Tooltip arrow
                                    placement={tooltipPlacement}
                                    title="Support Team Dashboard">
                                    <ListItem
                                        variant={path.startsWith("/support") ?
                                            "soft" :
                                            undefined}
                                        color={path.startsWith("/support") ?
                                            "success" :
                                            undefined}
                                    >
                                        <ListItemButton>
                                            <ListItemDecorator>
                                                <SupportAgentIcon color="success" />
                                            </ListItemDecorator>
                                            <ListItemContent>Support Team</ListItemContent>
                                        </ListItemButton>
                                    </ListItem>
                                </Tooltip>
                            </SidebarLink>
                        </AssistantOnly>
                    }


                    {currentIdentity.role == 'assistant' && rolesNames.includes('manager') &&
                        <AssistantOnly>
                            <SidebarLink to="/manager">
                                <Tooltip arrow
                                    placement={tooltipPlacement}
                                    title="Manager Team Dashboard">
                                    <ListItem
                                        variant={path.startsWith("/manager") ?
                                            "soft" :
                                            undefined}
                                        color={path.startsWith("/manager") ?
                                            "primary" :
                                            undefined}
                                    >
                                        <ListItemButton>
                                            <ListItemDecorator>
                                                <AdminPanelSettingsOutlined  />
                                            </ListItemDecorator>
                                            <ListItemContent >Manager</ListItemContent>
                                        </ListItemButton>
                                    </ListItem>
                                </Tooltip>
                            </SidebarLink>
                        </AssistantOnly>
                    }


                    <Stack pt={2}>
                        <SidebarLink
                            to="/account">
                            <Tooltip
                                placement={tooltipPlacement}
                                arrow
                                title="Update your account and change your settings">
                                <ListItem
                                    variant={section == "account" ? "soft" : undefined}
                                    color={section == "account" ? "primary" : undefined}
                                >
                                    <ListItemButton>
                                        <ListItemDecorator>
                                            <SettingsIcon />
                                        </ListItemDecorator>
                                        <ListItemContent>Account</ListItemContent>
                                    </ListItemButton>
                                </ListItem>
                            </Tooltip>
                        </SidebarLink>

                        <SidebarLink
                            to="/support">
                            <Tooltip arrow
                                placement={tooltipPlacement}
                                title="Need help with something?">
                                <ListItem
                                    variant={path == "/support" ? "soft" : undefined}
                                    color={path == "/support" ? "primary" : undefined}
                                >
                                    <ListItemButton>
                                        <ListItemDecorator>
                                            <ContactSupportIcon color="success" />
                                        </ListItemDecorator>
                                        <ListItemContent>Support</ListItemContent>
                                    </ListItemButton>
                                </ListItem>
                            </Tooltip>
                        </SidebarLink>

                    </Stack>




                    <Tooltip arrow placement="top" title={`That's ${year - 2010} years old in human years.`}>
                        <ListItem >

                            <ListItemDecorator>
                                <CopyrightIcon sx={{ opacity: 0.7 }} />
                            </ListItemDecorator>
                            <ListItemContent>
                                <Stack>
                                    <Typography level="body-sm"
                                        fontWeight="lg"
                                        sx={{ cursor: 'default' }} >
                                        Fancy Hands, Inc.
                                    </Typography>


                                    <Typography sx={{ cursor: 'pointer' }} level="body-xs">
                                        Established 2010
                                    </Typography>

                                </Stack>
                            </ListItemContent>

                        </ListItem>
                    </Tooltip>

                    <ListItem >

                        <ListItemDecorator>

                        <Tooltip arrow title={ showingRegularSidebar ? "Hide this menu" : "Keep this menu open" }>

                            {showingRegularSidebar ?
                                <HideSidebarIcon sx={{ opacity: 0.4 }}
                                    onClick={() => setShowingRegularSidebar && setShowingRegularSidebar(!showingRegularSidebar)} />
                                : <PinSidebarIcon
                                      onClick={() => {setShowingRegularSidebar && setShowingRegularSidebar(!showingRegularSidebar); navigate('/') }} />}
                                    </Tooltip>

                        </ListItemDecorator>
                        <ListItemContent>

                            <Tooltip arrow title="Are you connected to the server?">
                                <Chip sx={{
                                    textTransform: 'capitalize',
                                    transition: 'all 0.5s ease-in-out',
                                }} color={connectionStateColor}>{connectionState}</Chip>
                            </Tooltip>
                            {connectionState == 'disconnected' &&
                                <Typography level="body-xs" sx={{ cursor: 'pointer' }} >
                                    {connectionRetryDelay > 0 && `Reconnecting in ${connectionRetryDelay / 1000} seconds`}
                                </Typography>
                            }
                        </ListItemContent>
                    </ListItem>

                </SidebarList>


            </Box>


        </Stack>
    );
});

export function SidebarContained() {
    const { showingSidebar } = useSidebar();
    return (
        <Stack
            // className="Sidebar"
            sx={() => ({
                position: (showingSidebar ? '' : 'fixed'),
                top: 0,
                bottom: 0,
                maxWidth: (showingSidebar ? 'auto' : `var(--SidebarWidth) `),
                width: (showingSidebar ? 'auto' : `var(--SidebarWidth) `),

                left: 0,
                overflow: "auto",
                zIndex: 900,

                p: 1,
                mt: 0,
                ml: 0,

                // borderRight: (!showingSidebar ? `1px solid ${theme.vars.palette.divider}` : ''),
                // borderBottom: (!showingSidebar ? `1px dashed ${theme.vars.palette.divider}` : ''),

            })}
        >
            <Sidebar  />

        </Stack>
    );
}


export default Sidebar;
